import React from 'react';
import type { FC } from 'react';
import { Text } from 'ink';

//ASCII symbol, no need to check unicode support
const SCROLL_SYMBOL = '█';

interface ScrollProps {
  height: number;
  totalRowCounts: number;
  firstShownRow: number;
}

export const Scroll: FC<ScrollProps> = ({
  height,
  totalRowCounts,
  firstShownRow,
}) => {
  const scroll = [];
  const filledAmount = Math.round((height / totalRowCounts) * height);
  const filledStartIndex =
    firstShownRow === 0
      ? 0
      : Math.max(
          1,
          Math.floor(
            (firstShownRow / (totalRowCounts - height)) *
              (height - filledAmount)
          )
        );
  const filledEndIndex = filledStartIndex + filledAmount - 1;

  for (let i = 0; i < height; i++) {
    scroll.push(
      <Text
        color={i >= filledStartIndex && i <= filledEndIndex ? 'white' : 'gray'}
        key={`scroll-element-${i}`}
      >
        {SCROLL_SYMBOL}
      </Text>
    );
  }

  return scroll;
};
